"use client";

import type React from "react";
import styles from "./styles.module.css";

const CardSkeleton: React.FC = () => {
	return (
		<div className={styles.card}>
			<div className={styles.cardImage} />
			<div className={styles.cardBody}>
				<div className={styles.cardTitle} />
				<div className={styles.cardAddress} />
				<div className={styles.cardPriceBlock}>
					<div className={styles.cardPrice} />
					<div className={styles.cardPriceSmall} />
				</div>
				<div className={styles.cardText} />
				<div className={styles.cardTextShort} />
			</div>
		</div>
	);
};

const FiltersSkeleton: React.FC = () => {
	return (
		<aside className={styles.filters}>
			<div className={styles.filtersTitle} />
			{Array.from({ length: 8 }).map((_, i) => (
				<div className={styles.filterBlock} key={i}>
					<div className={styles.filterLabel} />
					<div className={styles.filterInputRow}>
						<div className={styles.filterInput} />
						<div className={styles.filterInput} />
					</div>
				</div>
			))}
		</aside>
	);
};

const CatalogSkeleton: React.FC = () => {
	return (
		<div className={styles.wrap}>
			<FiltersSkeleton />
			<div className={styles.content}>
				<div className={styles.list}>
					{Array.from({ length: 3 }).map((_, i) => (
						<CardSkeleton key={i} />
					))}
				</div>
				<div className={styles.pagination}>
					<div className={styles.pageDot} />
					<div className={styles.pageDot} />
					<div className={styles.pageDot} />
					<div className={styles.pageDot} />
				</div>
			</div>
		</div>
	);
};

export default CatalogSkeleton;
